import type { FreightSettingsState } from './freight-settings.types';

export const selectIsDisconnecting = (state: FreightSettingsState): boolean => state.isDisconnecting ?? false;
export const selectHasError = (state: FreightSettingsState): boolean => state.hasError ?? false;
export const selectErrorMessage = (state: FreightSettingsState): string => state.errorMessage ?? '';
